import React from 'react';
export default ((createSubscription, deps = []) => React.useEffect(() => {
  const subscription = createSubscription();
  return () => subscription.unsubscribe();
}, deps));